import { authenticate } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

/**
 * Fetches coins supported by the mining pool 
 */
const AuthenticateAPIKey = async (apiKey) => {
  try {
    const response = await authenticate(apiKey);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: extractApiErrorMessage(error) };
  }
};

export default AuthenticateAPIKey;